import React, { useState, useEffect } from 'react';
import '../styles/Citywise_on_duty_doctors.css';

const getToday = () => {
     const d = new Date();
     return d.toISOString().slice(0, 10);
};

const extractCityFromLocation = (location, cities) => {
     if (!location) return null;
     const found = cities.find(city =>
          location.toLowerCase().includes(city.city.toLowerCase())
     );
     return found ? found.city : null;
};

const CitywiseOnDutyDoctors = () => {
     const [cities, setCities] = useState([]);
     const [doctors, setDoctors] = useState([]);
     const [loading, setLoading] = useState(true);

     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const token = sessionStorage.getItem('token');

     useEffect(() => {
          setLoading(true);
          fetch(`${BASE_URL}/getCity`)
               .then(res => res.json())
               .then(cityRes => {
                    if (cityRes.status && Array.isArray(cityRes.data)) {
                         setCities(cityRes.data);
                         const url = `${BASE_URL}/doctorSummary?date=${getToday()}&emp_type=DOCTOR`;
                         fetch(url, {
                              headers: {
                                   'Content-Type': 'application/json',
                                   'Authorization': `Bearer ${token}`,
                              }
                         })
                              .then(res => res.json())
                              .then(docRes => {
                                   if (docRes.status && docRes.data && Array.isArray(docRes.data.details)) {
                                        setDoctors(docRes.data.details);
                                   } else {
                                        setDoctors([]);
                                   }
                                   setLoading(false);
                              })
                              .catch(() => setLoading(false));
                    } else {
                         setCities([]);
                         setDoctors([]);
                         setLoading(false);
                    }
               })
               .catch(() => {
                    setCities([]);
                    setDoctors([]);
                    setLoading(false);
               });
     }, [BASE_URL, token]);

     // Group doctors by city (on-duty only)
     const doctorsByCity = {};
     cities.forEach(city => {
          doctorsByCity[city.city] = [];
     });

     doctors.forEach(doc => {
          if (
               doc.status &&
               doc.status.toLowerCase() === 'present' &&
               doc.punch_in &&
               (
                    !doc.punch_out ||
                    doc.punch_in === doc.punch_out
               )
          ) {
               let city = doc.city_name;
               if (!city || !city.trim()) {
                    city = extractCityFromLocation(doc.location_name, cities);
               }
               if (city && doctorsByCity[city]) {
                    doctorsByCity[city].push(doc);
               }
          }
     });

     const renderedCount = Object.values(doctorsByCity).reduce((sum, arr) => sum + (arr?.length || 0), 0);


     // Separate Hyderabad from other cities
     const hyderabadCity = cities.find(city => city.city.toLowerCase() === 'hyderabad');
     const otherCities = cities.filter(city => city.city.toLowerCase() !== 'hyderabad');

     if (loading) return <div className="loading">Loading...</div>;

     return (
          <div className="container-fluid py-0">
               <div className='row'>
                    <div className='col-8'>
                         <h5 className='mt-2 mb-2'>Total Doctors on duty: {renderedCount}</h5>
                    </div>
                    <div className='col-4'>
                         <button
                              type="button"
                              className='btn btn-success refresh-btn'
                              onClick={() => window.location.reload()}
                              aria-label="Refresh"
                         >
                              Refresh
                         </button>
                    </div></div>
               <div className="citywise-layout">
                    {/* Hyderabad Section - Full Width */}
                    {hyderabadCity && (
                         <div className="hyderabad-section">
                              <div className="city-brick">
                                   <div className="city-header">{hyderabadCity.city}</div>
                                   {doctorsByCity[hyderabadCity.city] && doctorsByCity[hyderabadCity.city].length > 0 ? (
                                        doctorsByCity[hyderabadCity.city].map((doc, idx) => (
                                             <div
                                                  key={doc.employee_code + idx}
                                                  className="doctor-item"
                                             >
                                                  <span className="fw-semibold">
                                                       {doc.employee_name && doc.employee_name.length > 20
                                                            ? doc.employee_name.slice(0, 20) + '...'
                                                            : doc.employee_name}
                                                  </span>
                                                  <span className='smallFont'>  {doc.location_name ? doc.location_name : 'N/A'} </span>
                                                  <span className="ms-2 text-primary">
                                                       {doc.punch_in
                                                            ? (() => {
                                                                 const match = doc.punch_in.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] + ':00' : match[1];
                                                                      return new Date(`1970-01-01T${timeStr}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'}
                                                  </span>
                                                  <span className="smallFont">
                                                       ( {doc.shift_details?.in_time
                                                            ? (() => {
                                                                 const match = doc.shift_details.in_time.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] : match[1].slice(0, 5);
                                                                      return timeStr;
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'} to{' '}
                                                       {doc.shift_details?.out_time
                                                            ? (() => {
                                                                 const match = doc.shift_details.out_time.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] : match[1].slice(0, 5);
                                                                      return timeStr;
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'} )
                                                  </span>
                                             </div>
                                        ))
                                   ) : (
                                        <div className="text-muted text-center" style={{ fontSize: '0.9em' }}>
                                             No on-duty doctors
                                        </div>
                                   )}
                              </div>
                         </div>
                    )}

                    {/* Other Cities - Two Column Masonry */}
                    <div className="citywise-masonry">
                         {otherCities.map(city => (
                              <div key={city.city} className="city-brick">
                                   <div className="city-header">{city.city}</div>
                                   {doctorsByCity[city.city] && doctorsByCity[city.city].length > 0 ? (
                                        doctorsByCity[city.city].map((doc, idx) => (
                                             <div
                                                  key={doc.employee_code + idx}
                                                  className="doctor-item"
                                             >
                                                  <span className="fw-semibold">
                                                       {doc.employee_name && doc.employee_name.length > 20
                                                            ? doc.employee_name.slice(0, 20) + '...'
                                                            : doc.employee_name}
                                                  </span>
                                                  <span className='smallFont'>  {doc.location_name ? doc.location_name : 'N/A'} </span>
                                                  <span className="ms-2 text-primary">
                                                       {doc.punch_in
                                                            ? (() => {
                                                                 const match = doc.punch_in.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] + ':00' : match[1];
                                                                      return new Date(`1970-01-01T${timeStr}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'}
                                                  </span>
                                                  <span className="smallFont">
                                                       ( {doc.shift_details?.in_time
                                                            ? (() => {
                                                                 const match = doc.shift_details.in_time.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] : match[1].slice(0, 5);
                                                                      return timeStr;
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'} to{' '}
                                                       {doc.shift_details?.out_time
                                                            ? (() => {
                                                                 const match = doc.shift_details.out_time.match(/\b(\d{2}:\d{2}(:\d{2})?)\b/);
                                                                 if (match) {
                                                                      const timeStr = match[1].length === 5 ? match[1] : match[1].slice(0, 5);
                                                                      return timeStr;
                                                                 }
                                                                 return 'N/A';
                                                            })()
                                                            : 'N/A'} )
                                                  </span>
                                             </div>
                                        ))
                                   ) : (
                                        <div className="text-muted text-center" style={{ fontSize: '0.9em' }}>
                                             No on-duty doctors
                                        </div>
                                   )}
                              </div>
                         ))}
                    </div>
               </div>
          </div>
     );
};

export default CitywiseOnDutyDoctors;